import { render, staticRenderFns } from "./TransactionEdit.vue?vue&type=template&id=cb5b4b74"
import script from "./TransactionEdit.vue?vue&type=script&lang=js"
export * from "./TransactionEdit.vue?vue&type=script&lang=js"
import style0 from "./TransactionEdit.vue?vue&type=style&index=0&id=cb5b4b74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports